import { ApiInterceptorAuthed } from './api.authed'

export const AgentService = {
  async customers(search: string, page: number = 1, itemsPerPage: number = 30): Promise<IAgentCustomersResponse> {
    const query = new URLSearchParams({
      page: String(page),
      itemsPerPage: String(itemsPerPage),
    })
    if (search) {
      query.set('search', search)
    }

    return ApiInterceptorAuthed<IAgentCustomersResponse>(`/api/agent/customers?${query.toString()}`, {
      method: 'GET',
    })
  },

  async impersonate(extId: string): Promise<IImpersonateResponse> {
    return ApiInterceptorAuthed<IImpersonateResponse>('/api/agent/impersonate', {
      method: 'POST',
      body: JSON.stringify({ extId }),
    })
  },

  async release(): Promise<{ status: string }> {
    return ApiInterceptorAuthed<{ status: string }>('/api/agent/release', {
      method: 'POST',
    })
  },
}
